import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, X } from "lucide-react";

// PATCH 35 M15 — lightweight, dismissible user-facing "What's New", benefit-first (distinct from A20).
export default function WhatsNew() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/polish/whats-new").then((r) => {
      const unseen = (r.data.items || []).filter((i) => !i.seen);
      setItems(r.data.items || []); setOpen(unseen.length > 0);
    }).catch(() => {});
  }, []);
  const dismiss = () => { setOpen(false); api.post("/polish/whats-new/seen").catch(() => {}); };
  if (!open || !items.length) return null;
  return (
    <div className="k-container k-fadein" data-testid="whats-new" style={{ padding: 16, marginBottom: 14, borderLeft: "3px solid var(--accent-primary)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Sparkles size={15} color="var(--accent-primary)" />
        <span className="k-heading" style={{ fontSize: 14, fontWeight: 700 }}>What's new</span>
        <button className="k-link" data-testid="whats-new-dismiss" aria-label="Dismiss" style={{ marginLeft: "auto" }} onClick={dismiss}><X size={14} /></button>
      </div>
      <div style={{ marginTop: 8, display: "grid", gap: 8 }}>
        {items.slice(0, 4).map((i) => (
          <div key={i.id} data-testid={`whats-new-${i.id}`}>
            <div className="k-heading" style={{ fontSize: 13, fontWeight: 600 }}>{i.title}</div>
            <div className="k-muted" style={{ fontSize: 12 }}>{i.body}{i.link && <> · <button className="k-link" style={{ fontSize: 12 }} onClick={() => { dismiss(); nav(i.link); }}>Take a look</button></>}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
